//companies-list.js
import React, { useEffect, useState } from "react";
import { getAllGym, getGymCount, changeGymStatus } from '../helper/api';
import { startLoader, stopLoader, useAsyncState } from '../../../lib/utils';
import * as config from '../../../config';
// import ManageGymForm from '../../components/modal/desktop/ManageGym';
// import ManageConfirmationModal from '../../components/modal/ConfirmModal';
import { ToastTime, ToastType } from '../../../components/toastMessage';
import Toast from '../../../lib/toast';
// import SearchFilter from '../../components/search-filter';
import { isAuthenticated } from "../../../auth";
import ManageConfirmationModal from "../../../components/modal/ConfirmModal";
import ManageGymForm from "../../../components/modal/desktop/ManageGym";
import ModalDrawer from '../../../components/modal-drawer';
var typingTimer;
var doneTypingInterval = 1000;


const ACTION_MENU_WIDTH = 130; 
const ACTION_MENU_GAP = 4;    

const getActionMenuStyle = (dropdownPosition) => ({
    position: "fixed",
    top: dropdownPosition.top,
    left: dropdownPosition.left,
    zIndex: 9999,
    margin: 0,
    width: `${ACTION_MENU_WIDTH}px`,
    minWidth: "unset",
    maxWidth: `${ACTION_MENU_WIDTH}px`,
    boxSizing: "border-box",
    transform: "none",
    transformOrigin: "top right"
});

const CompaniesList = (props) => {

  const [isAllGymListSelected, setAllGymListSelected] = useState(false);
   const pageSize = 14;
    const flag = 0;
    const [selectedGym, setSelectedGym] = useState('');
    //Pagination
    const [page, setpage] = useAsyncState(1);
    const [total, settotal] = useAsyncState(0);
    var [currentpage, setcurrentpage] = useState(1);
    const [Gyms, setGyms] = useAsyncState([]);
    // User Authentication
    const { user, token } = isAuthenticated();
    const [selectedGymIds, setSelectedGymIds] = useState([]);
    var [gymType, setGymType] = useAsyncState("commercial");
    const [isAddGymModalOpen, setAddGymModalOpen] = useState(false);
    const [isStatusChangeModalOpen, setStatusChangeModal] = useState(false);
    const [isGymProfileViewOpen, setGymProfileViewOpen] = useState(false);
    const [isGymActionDropdownOpenId, setGymActionDropdownOpenId] = useState("");
    const [dropdownPosition, setDropdownPosition] = useState({top:0, left:0});
    const [isBulkStatusChangeAction, setBulkStatusChangeAction] = useState(false);
    const [isAllGymChecked, setAllGymChecked] = useState(false);
    const [isGymFilterOpen, setGymFilterOpen] = useState(false);
    var [isGymActive, setGymActive] = useAsyncState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [isMemberSpinnerLoader, setMemberSpinnerLoader] = useState(false);
    const [currentGymDetailsOpen, setCurrentGymDetailsOpen] = useState(-1);


    const searchGym = async () => {
        try {
            await startLoader()
            await GetAllGyms();
            await GetGymCount();
            await stopLoader();
        } catch (error) {
            // do something
        }
    }

    const handleAction = async event => {
        event.preventDefault();
        try {
            await startLoader();
            let status = (isBulkStatusChangeAction ? isGymActive : (!selectedGym.deletedAt || selectedGym.deletedAt == null)) ? "deactivate" : "activate";
            let gymIDs = isBulkStatusChangeAction ? selectedGymIds : [selectedGym._id];
            if (isAllGymChecked) {
                gymIDs = await Gyms.map(gym => gym._id);
            }
            await changeGymStatus(user._id, token, status, { gymIDs });
            handleStatusChangeAction();
            setBulkStatusChangeAction(false);
            setAllGymChecked(false);
            setSelectedGymIds([]);
            setSelectedGym('');
            showToast({ type:ToastType.success, message:`Gym ${status == 'deactivate'? 'Deactivated':'Activated'}  successfully`, duration: ToastTime.SHORT });
            await GetGymCount();
            await GetAllGyms();
            await stopLoader();
        } catch (error) {
            showToast({ type:ToastType.error, message:"Unable to update gym detail", duration: ToastTime.SHORT });
            await stopLoader();
        }
        event.stopPropagation()
    }


    const handleStatusChangeAction = event => {
        setStatusChangeModal(!isStatusChangeModalOpen);
        setBulkStatusChangeAction(false);
    }

    const handleBulkStatusChnageAction = event => {
        setStatusChangeModal(!isStatusChangeModalOpen);
        setBulkStatusChangeAction(true);
    }

    const toggleAddGymModal = () => {
        if (isAddGymModalOpen) {
            setAddGymModalOpen(false)
        } else {
            setAddGymModalOpen(true)
        }
    }




    const handleGymType = item => async event => {
        try {
            event.preventDefault();
            await startLoader()
            gymType = item
            await setGymType(gymType);
            await setGyms([]);
            await GetGymCount();
            await GetAllGyms();
            await stopLoader()
            event.stopPropagation();
        } catch (error) {
            //do something
        }
    }

    const handleSelectedGymIds = selectedId => event => {

        let list = [...selectedGymIds];
        let findIndex = list.indexOf(selectedId);
        if (findIndex == -1) {
            list.push(selectedId);
        } else {
            list.splice(findIndex, 1);
        }
        setSelectedGymIds(list)
        event.stopPropagation()
    }
 
    const prev = async () => {
        await startLoader()
        if (currentpage <= page && currentpage != 1) {
            currentpage=currentpage-1;
            setcurrentpage(currentpage);
            await GetAllGyms();
        }
        await stopLoader()
    };
    const next = async (isMobileLoadMore) => {
        if (isMobileLoadMore) {
            if (currentpage < page && !isMemberSpinnerLoader) {
                setMemberSpinnerLoader(true);
                currentpage = currentpage + 1;
                setcurrentpage(currentpage);
                await GetAllGyms(false, true);
                setMemberSpinnerLoader(false);
            }
            return;
        }
        await startLoader()
        if (currentpage < page) {
            currentpage=currentpage+1;
            setcurrentpage(currentpage);
            await GetAllGyms();
        }
        await stopLoader()
    };

 
    const toggleGymAction = (gym) => event => {
        let gymId = gym._id;
        if (isGymActionDropdownOpenId == gym._id) gymId = "";
        else {
            setSelectedGym(gym);
            const rect = event.currentTarget.getBoundingClientRect();
            const viewportWidth = window.innerWidth;

            
            let left = rect.right - ACTION_MENU_WIDTH;
            if (left < 8) left = 8; // don't overflow left edge
            if (left + ACTION_MENU_WIDTH > viewportWidth - 8) {
                left = viewportWidth - ACTION_MENU_WIDTH - 8; 
            }

            setDropdownPosition({
                top: rect.bottom + ACTION_MENU_GAP,
                left
            });
        }
        setGymActionDropdownOpenId(gymId)
        event.stopPropagation();
    }

    const handleGymMoreDetails = (index) => {
        if (currentGymDetailsOpen != index) {
            setCurrentGymDetailsOpen(index);
        } else {
            setCurrentGymDetailsOpen(-1);
        }
    }


    //Get All Gym's
    const getGymParams = () => {
        let param = {
            pageNo: currentpage,
            pageSize: pageSize,
            isFilterByProfile:true
        }
        param.activationStatus = isGymActive ? "active" : "inactive";
        if (gymType) param.type = gymType;
        if (searchQuery && searchQuery.length > 0) param.q = searchQuery;
        return param;
    }
    const GetAllGyms = async (isReload, isAppend) => {
        try {
            let param = getGymParams();
            let gyms = await getAllGym(user._id, token, param);
            if (gyms && gyms.error) {
                setGyms([])
            } else {
                setGyms(isReload?gyms:(isAppend?[...Gyms,...gyms]:[...Gyms,...gyms]));
            }
        } catch (error) {
            
        }
    }
    const GetGymCount = async () => {
        try {
            let param = getGymParams();
            delete param.pageNo;
            delete param.pageSize;
            let response = await getGymCount(user._id, token, param);
            setpage(Math.ceil(response.COUNT / pageSize));
            settotal(response.COUNT);
        } catch (error) {
            
        }
    }

    const handleUpdateOpen = gym => event => {
        event.preventDefault()
        toggleAddGymModal();
    };


    const ongymSelect = data => event => {
        try {
            event.preventDefault();
            setSelectedGym(data);
            setGymProfileViewOpen(true);
            event.stopPropagation();
        } catch (error) {
            
        }
    }


    const checkAllGym = () => {
      if (isAllGymChecked) {
          setAllGymChecked(false)
      } else {
          setAllGymChecked(true)
      }
    }


    const handleGymFilter = () => {
        if (isGymFilterOpen) {
            setGymFilterOpen(false)
        } else {
            setGymFilterOpen(true)
        }
    }

    const toggleActiveInactiveButton = async event => {
        try {
            event.preventDefault();
            await startLoader()
            isGymActive = !isGymActive;
            await setGymActive(isGymActive)
            await setGyms([]);
            await GetAllGyms();
            await GetGymCount();
            await stopLoader()
            event.stopPropagation();
        } catch (error) {
           
        }
    }

    const showToast=(data)=>{
        new Toast(data);
    }

    const handleSearchingData = (searchedData) => {
       setSearchQuery(searchedData);
    } 

    const handleMobileScroll = async event => {
        try {
            const { offsetHeight, scrollTop, scrollHeight } = event.target;

         
            const STICKY_THRESHOLD = 130;
            const isCurrentlySticky = scrollTop > STICKY_THRESHOLD;

            const bottomMenu = document.querySelector('.bottom-menu');
            if (bottomMenu) {
                if (isCurrentlySticky) {
                    bottomMenu.style.marginBottom = `-${bottomMenu.offsetHeight}px`;
                } else {
                    bottomMenu.style.marginBottom = `0px`;
                }
            }

            if (props.handleStickyChange) {
                props.handleStickyChange(isCurrentlySticky);
            }

            if (offsetHeight + scrollTop >= scrollHeight - 5) {
                await next(true);
            }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        window.addEventListener("click", () => {
            setGymActionDropdownOpenId('')
        })
    }, [isGymActionDropdownOpenId])

    useEffect(async () => {
        try {
            await startLoader()
            await GetAllGyms();
            await GetGymCount();
            await stopLoader()
        } catch (error) {
            await startLoader()
        }
    }, [props])

    useEffect(() => {
        
        let searchGymInputField = document.getElementById("search-gym-input");
        let searchContainer = document.getElementById("search-container");
        let searchIcon = document.getElementById("search-icon");
        if (searchGymInputField) {
            searchGymInputField.onfocus = e => {
                searchContainer.style.outline = "1px solid var(--darkBlue)";
                searchContainer.style.boxShadow = "0px 2px 4px rgba(0, 0, 0, 0.25)";
                searchIcon.classList.add("active-fill-svg");
            }
            searchGymInputField.onblur = e => {
                searchContainer.style.outline = "none";
                searchContainer.style.boxShadow = "none";
                searchIcon.classList.remove("active-fill-svg");
            }
            searchGymInputField.onkeyup = e => {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(searchGym, doneTypingInterval);
            };
            searchGymInputField.onkeydown = e => {
                clearTimeout(typingTimer);
            }
        }

    }, [])

    useEffect(() => {
        window.addEventListener("click", () => {
            setGymFilterOpen(false)
        })
    },[isGymFilterOpen]);

    useEffect(async () => {
        await startLoader()
        await GetAllGyms();
        await GetGymCount();
        await stopLoader();
    },[searchQuery])

  if (window.innerWidth < 768) {
    return (
   
      <div
        id="container"
        className="main-container main-container-auto"
        onScroll={handleMobileScroll}
        style={{
          height: "100vh", 
          overflowY: "auto",
          WebkitOverflowScrolling: "touch"
        }}
      >
        {props.mobileHeader} 
        <div className="w-full" style={{padding:"8px 16px"}}>
          {
            Gyms.map((gym, index) => {
              return (
                <div className="w-full p-b-12 m-t-12" style={{borderBottom:"1px solid #FFFFFF"}} key={gym._id}>
                  <div className="d-flex w-full space-between">
                    <div className="d-flex">
                      <input onClick={handleSelectedGymIds(gym._id)} className="flex-item m-r-8" type="checkbox" checked={selectedGymIds.indexOf(gym._id) != -1} style={{width:"18px", height:"18px"}} readOnly />
                      {
                        gym.logoFileID ?
                          <div className='table-item-profile flex-item m-r-8'>
                            <img id="gym-ImgWrapper" src={`${config.API_URL}/image/file/${gym.logoFileID}/30/30/70`} loading='lazy' />
                          </div>
                          : <div className="table-item-profile m-r-8 flex-item d-flex" style={{
                              backgroundColor: gym.logoPlaceholderColor ? gym.logoPlaceholderColor : "#5d883c"
                          }}>
                              <p className='flex-item' style={{
                                  color: "#ffffff",
                                  margin: "0 auto",
                                  fontSize: 14,
                                  textTransform:"uppercase"
                              }}>{`${gym.name}`.trim()[0]}</p>
                          </div>
                      }
                      <div className='flex-item m-l-8'>
                        <p className="color-black fs-16 font-weight-600" style={{lineHeight:"16px"}}>{gym.name}</p>
                      </div>
                    </div>
                      <div className="flex-item d-flex" style={{position:"relative"}}>
                        <div onClick={toggleGymAction(gym)} className="table-action-button d-flex m-r-16" style={{backgroundColor: isGymActionDropdownOpenId == gym._id ? "#E33A34" : "#ffffff"}}>
                        {
                          isGymActionDropdownOpenId == gym._id? (
                            <svg className="flex-item margin-auto" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.5 19L18.5 6M18.5 19L5.5 6" stroke="#ffffff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          ) : (
                            <svg className="flex-item svg-fill-circle margin-auto" width="17" height="5" viewBox="0 0 17 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="2.27778" cy="2.50054" r="1.77778" transform="rotate(-90 2.27778 2.50054)" fill="#9A9A9A"/>
                              <circle cx="8.50043" cy="2.50054" r="1.77778" transform="rotate(-90 8.50043 2.50054)" fill="#9A9A9A"/>
                              <circle cx="14.7231" cy="2.50054" r="1.77778" transform="rotate(-90 14.7231 2.50054)" fill="#9A9A9A"/>
                            </svg>
                          )
                        }
                        </div>

                        <div onClick={()=>handleGymMoreDetails(index)} className="table-action-button d-flex" style={{backgroundColor: currentGymDetailsOpen == index ? "#E33A34" : "#ffffff"}}>
                          <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: currentGymDetailsOpen == index ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={currentGymDetailsOpen == index ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                          </svg>
                        </div>

                        {
                          isGymActionDropdownOpenId == gym._id && (
                            <div
                              className="table-action-menu scaleFromTopToBottom"
                              style={getActionMenuStyle(dropdownPosition)}
                            >
                              <div onClick={handleUpdateOpen(gym)} className="action-menu-item d-flex">
                                <div className="flex-item d-flex m-r-8" style={{width:"24px"}}>
                                  <svg className='flex-item m-r-8' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.5828 1.41713C14.1024 0.936821 13.4508 0.666992 12.7715 0.666992C12.0921 0.666992 11.4406 0.936821 10.9602 1.41713L1.90097 10.4775C1.63678 10.7415 1.4545 11.0762 1.37606 11.4413L0.67774 14.6996C0.659324 14.7852 0.662646 14.874 0.687401 14.958C0.712157 15.0419 0.757556 15.1183 0.819453 15.1802C0.88135 15.2421 0.95777 15.2875 1.04173 15.3123C1.12569 15.337 1.21452 15.3403 1.3001 15.3219L4.55855 14.6237C4.92372 14.5452 5.25845 14.3629 5.52247 14.0988L14.5828 5.03896C15.0629 4.5586 15.3327 3.90722 15.3327 3.22804C15.3327 2.54886 15.0629 1.89749 14.5828 1.41713ZM11.7015 2.15784C11.9879 1.88696 12.3688 1.7385 12.763 1.74403C13.1572 1.74955 13.5337 1.90862 13.8124 2.18742C14.0912 2.46622 14.2502 2.84274 14.2556 3.23693C14.261 3.63112 14.1125 4.01188 13.8415 4.29825L13.37 4.7697L11.2295 2.62982L11.7015 2.15784ZM10.4882 3.37053L12.6287 5.51094L4.78225 13.3586C4.66083 13.4799 4.50692 13.5636 4.33905 13.5995L1.87111 14.1286L2.40022 11.6613C2.43615 11.4935 2.51983 11.3396 2.6412 11.2182L10.4882 3.37053Z" fill="var(--darkBlue)"/>
                                  </svg>
                                </div>
                                <p className="flex-item">Edit</p>
                              </div>
                              <div onClick={handleStatusChangeAction} className="action-menu-item d-flex">
                                <div className="flex-item d-flex m-r-8" style={{width:"24px"}}>
                                  <svg className='flex-item m-r-8' width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.196 4.76233C2.90164 5.86082 2.93963 7.02194 3.30516 8.09884C3.6707 9.17574 4.34737 10.1201 5.2496 10.8124C6.15183 11.5047 7.2391 11.914 8.37391 11.9883C9.50872 12.0627 10.6401 11.7989 11.625 11.2303M14.304 7.73833C14.5984 6.63984 14.5604 5.47873 14.1948 4.40183C13.8293 3.32492 13.1526 2.3806 12.2504 1.68827C11.3482 0.995947 10.2609 0.586711 9.1261 0.512318C7.99129 0.437925 6.8599 0.701717 5.875 1.27033" stroke="var(--darkBlue)" stroke-linecap="round"/>
                                    <path d="M0.5 6.75034L3 4.25034L5.5 6.75034M12 5.75034L14.5 8.25034L17 5.75034" stroke="var(--darkBlue)" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </div>
                                <p className="flex-item">{(!gym.deletedAt || gym.deletedAt == null) ? `Mark Inactive` : `Mark Active`}</p>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  {
                    currentGymDetailsOpen == index && (
                      <div className="member-more-info scaleFromTopToBottom m-t-12 m-b-8">
                        <div className="info-header d-flex">
                          <p className="fs-16 color-black font-weight-700 flex-item">Company Info</p>
                        </div>
                        <div className="member-info-container" style={{paddingLeft:"6px"}}>
                          <div className="d-flex w-full space-between m-b-8">
                            <div className="d-flex item-type">
                              <svg className="flex-item m-r-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.18795 8.35171C6.96757 6.92938 7.99369 5.64962 9.56121 5.18004C9.83953 5.09672 10.1399 5.12039 10.4009 5.24624C10.662 5.37208 10.8642 5.59062 10.9662 5.85726L11.4688 7.16983C11.5497 7.38097 11.5641 7.61091 11.5104 7.83015C11.4568 8.0494 11.3373 8.24796 11.1675 8.40037L9.67227 9.7418C9.59838 9.80796 9.54334 9.89176 9.51251 9.98498C9.48169 10.0782 9.47615 10.1777 9.49643 10.2736L9.50973 10.3325L9.54675 10.4801C9.57972 10.6046 9.62946 10.78 9.69945 10.9893C9.83827 11.4051 10.0598 11.9641 10.3895 12.5225C10.7192 13.0809 11.1033 13.5483 11.4017 13.8736C11.5573 14.0428 11.7198 14.2059 11.8888 14.3624L11.935 14.4043C12.0098 14.469 12.1005 14.5138 12.1982 14.5341C12.2959 14.5544 12.3974 14.5497 12.4926 14.5202L14.428 13.9245C14.6479 13.8569 14.8835 13.8551 15.1044 13.9193C15.3254 13.9835 15.5217 14.1108 15.6682 14.2849L16.5838 15.3723C16.9656 15.8249 16.9204 16.4902 16.4814 16.8902C15.2818 17.9839 13.6321 18.2085 12.4845 17.3055C11.0782 16.1955 9.89246 14.8421 8.98626 13.3129C8.07341 11.7842 7.46332 10.1015 7.18795 8.35171ZM10.7082 10.3477L11.9495 9.23431C12.2892 8.92949 12.5281 8.53237 12.6354 8.09387C12.7428 7.65538 12.7138 7.19551 12.5522 6.77323L12.049 5.46066C11.8437 4.92438 11.437 4.48488 10.9119 4.23174C10.3868 3.9786 9.7827 3.93087 9.22283 4.0983C7.27645 4.6816 5.71356 6.38851 6.04442 8.52088C6.34141 10.4116 7.00017 12.2306 7.98617 13.8826C8.96358 15.5317 10.2425 16.9911 11.7592 18.1881C13.48 19.5403 15.7786 19.0792 17.2704 17.7185C17.6975 17.3295 17.9567 16.7958 17.995 16.2262C18.0334 15.6566 17.8481 15.0942 17.4769 14.6538L16.5612 13.5664C16.2682 13.2181 15.8755 12.9634 15.4335 12.835C14.9915 12.7065 14.5203 12.7102 14.0804 12.8456L12.4741 13.3401C12.4022 13.2677 12.3318 13.194 12.263 13.1188C11.9328 12.7617 11.6407 12.3725 11.3913 11.9573C11.1483 11.5384 10.9496 11.0964 10.7984 10.638C10.7663 10.542 10.7363 10.4454 10.7082 10.3483" fill="#6D6D6D"/>
                              </svg>
                              <p className="flex-item">Phone</p>
                            </div>
                            <p className="flex-item item-value font-weight-600 color-dark-blue">{gym.phone || "-"}</p>
                          </div>
                          <div className="d-flex w-full space-between m-b-8">
                            <div className="d-flex item-type">
                              <svg className="flex-item m-r-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 7H6C5.73478 7 5.48043 7.10536 5.29289 7.29289C5.10536 7.48043 5 7.73478 5 8V16C5 16.2652 5.10536 16.5196 5.29289 16.7071C5.48043 16.8946 5.73478 17 6 17H18C18.2652 17 18.5196 16.8946 18.7071 16.7071C18.8946 16.5196 19 16.2652 19 16V8C19 7.73478 18.8946 7.48043 18.7071 7.29289C18.5196 7.10536 18.2652 7 18 7ZM16.9 8L12 11.39L7.1 8H16.9ZM6 16V8.455L11.715 12.41C11.7987 12.4681 11.8981 12.4992 12 12.4992C12.1019 12.4992 12.2013 12.4681 12.285 12.41L18 8.455V16H6Z" fill="#6D6D6D"/>
                              </svg>
                              <p className="flex-item">Email</p>
                            </div>
                            <p className="flex-item item-value font-weight-600 color-dark-blue">{gym.email || "-"}</p>
                          </div>
                          <div className="d-flex w-full space-between">
                            <div className="d-flex item-type">
                              <svg className="flex-item m-r-4" width="24" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.6 17.2379H15.9424C13.7332 17.2379 11.9424 15.447 11.9424 13.2379V10.6317C11.9424 8.42257 13.7332 6.63171 15.9424 6.63171H16.6" stroke="#6D6D6D"/>
                                <path d="M19.1 6.63171C19.1 7.30616 18.543 7.86343 17.8428 7.86343C17.1427 7.86343 16.5857 7.30616 16.5857 6.63171C16.5857 5.95727 17.1427 5.4 17.8428 5.4C18.543 5.4 19.1 5.95727 19.1 6.63171Z" stroke="#6D6D6D" stroke-width="0.8"/>
                                <path d="M19.1 17.2379C19.1 17.9123 18.543 18.4696 17.8428 18.4696C17.1427 18.4696 16.5857 17.9123 16.5857 17.2379C16.5857 16.5634 17.1427 16.0061 17.8428 16.0061C18.543 16.0061 19.1 16.5634 19.1 17.2379Z" stroke="#6D6D6D" stroke-width="0.8"/>
                                <path d="M7.89368 12.1387H16.6049" stroke="#6D6D6D"/>
                                <path d="M19.1 11.9348C19.1 12.6092 18.543 13.1665 17.8428 13.1665C17.1427 13.1665 16.5857 12.6092 16.5857 11.9348C16.5857 11.2603 17.1427 10.7031 17.8428 10.7031C18.543 10.7031 19.1 11.2603 19.1 11.9348Z" stroke="#6D6D6D" stroke-width="0.8"/>
                                <path d="M7.91429 11.9348C7.91429 12.6092 7.3573 13.1665 6.65714 13.1665C5.95699 13.1665 5.4 12.6092 5.4 11.9348C5.4 11.2603 5.95699 10.7031 6.65714 10.7031C7.3573 10.7031 7.91429 11.2603 7.91429 11.9348Z" stroke="#6D6D6D" stroke-width="0.8"/>
                              </svg>
                              <p className="flex-item">Type</p>
                            </div>
                            <p className="flex-item item-value font-weight-600 color-dark-blue" style={{textTransform:"capitalize"}}>{gym.type || "-"}</p>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </div>
              )
            })
          }

          {
            Gyms.length == 0 && (
              <div className="d-flex w-full m-t-40" style={{justifyContent:"center"}}>
                <p className="fs-14 color-grey-02">No gyms found</p>
              </div>
            )
          }

          {
            isMemberSpinnerLoader && <div className="loader-5 center"><span></span></div>
          }
        </div>

       {
        isAddGymModalOpen && ( <ModalDrawer modalHeader="Edit Company" modalType="edit-company" company={{ ...selectedGym }} reload={searchGym} handleCloseModal={toggleAddGymModal} toggleManageCompanyModal={toggleAddGymModal} />)
       } 

        {
          isStatusChangeModalOpen && <ManageConfirmationModal isMobile={true} handleAction={handleAction} title={isBulkStatusChangeAction ? `${isAllGymChecked ? Gyms.length : selectedGymIds.length} gym(s) selected` : selectedGym.name} message="By performing this action all the user's under this gym will get effected" buttonText={`Mark ${isBulkStatusChangeAction ? (isGymActive ? "inactive" : "active") : (selectedGym.deletedAt == null ? "inactive" : "active")}`} handleClose={handleStatusChangeAction} />
        }
      </div>
    )
  }

  return[
    <div className="scrollable-body m-t-12" style={{zIndex:0}}>
      <div className="flex-item scrollable-table-xy">
        <div className="scrollable-table-header" style={{zIndex:2}}>
          <div className="fixed-container d-flex">
            <div onClick={checkAllGym} checked={isAllGymChecked} className="checkbox-container d-flex">
              {
                isAllGymChecked ? (
                  <svg className="flex-item margin-auto" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="6" fill="#0090D7"/>
                    <path d="M6 13.16L10.3333 18L19 7" stroke="white" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                ) : (
                  <svg className="flex-item margin-auto" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="6" fill="white"/>
                  </svg>
                )
              }
            </div>
            <div className="header-middle-container d-flex">
              <div className="item-container item-container-6 d-flex">
                <p className="flex-item d-flex color-white">Name</p>
              </div>
              <div className="item-container item-container-6 d-flex">
                <p className="flex-item d-flex color-white">Email</p>
              </div>
              <div className="item-container item-container-2 d-flex">
                <p className="flex-item d-flex color-white">Contact</p>
              </div>
            </div>
            <div className="action-container d-flex">
              <p className="flex-item color-white fs-16 color-white margin-auto">Action</p>
            </div>
          </div>
        </div>
        {
          Gyms.map((gym) => {
            return (
              <div className="d-flex scrollable-table-body" key={gym._id}>
                <div onClick={handleSelectedGymIds(gym._id)} className="checkbox-container checkbox-container-body d-flex" style={{borderBottom:"1px solid #C3C3C3"}}>
                  {
                    (selectedGym && selectedGym._id == gym._id) ? (
                      <svg className="flex-item margin-auto" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="24" rx="6" fill="#0090D7"/>
                        <path d="M6 13.16L10.3333 18L19 7" stroke="white" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                    ) : (
                      <svg className="flex-item margin-auto" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="24" rx="6" fill="white"/>
                      </svg>
                    )
                  }
                </div>
                <div className="scrollable-table-body-middle-container d-flex" style={{borderBottom:"1px solid #dadada"}}>
                  <div className='item-container item-container-6 d-flex'>
                      {
                        gym.logoFileID ?
                          <div className='gym-logo flex-item m-r-8'>
                              <img id="gym-ImgWrapper" src={`${config.API_URL}/image/file/${gym.logoFileID}/auto/auto/70`} loading='lazy' className="gym-logo" />
                          </div>
                          : <div className="gym-logo m-r-8 flex-item d-flex" style={{
                              backgroundColor: gym.logoPlaceholderColor ? gym.logoPlaceholderColor : "#5d883c"
                          }}>
                              <p className='flex-item' style={{color: "#ffffff", margin: "0 auto",fontSize: 14,}}>{`${gym.name}`.trim()[0]}</p>
                            </div>
                      }
                      <p className='flex-item'>{gym.name}</p>
                  </div>
                  <div className='item-container item-container-6 d-flex'>
                    <p className='flex-item'>{gym.email}</p>
                  </div>
                  <div className='item-container item-container-2 d-flex'>
                    <p className='flex-item'>{gym.phone}</p>
                  </div>
                </div>
                <div onClick={(e)=>e.stopPropagation()} className="action-container action-container-body d-flex" style={{borderBottom:"1px solid #C3C3C3", zIndex: isGymActionDropdownOpenId == gym._id && 10}}>
                  <div onClick={toggleGymAction(gym)} className="d-flex table-action-button cursor-pointer margin-auto" style={{backgroundColor: isGymActionDropdownOpenId == gym._id ? "#E33A34" : "#ffffff"}}>
                    {
                      isGymActionDropdownOpenId == gym._id? (
                        <svg className="flex-item margin-auto" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.5 19L18.5 6M18.5 19L5.5 6" stroke="#ffffff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      ) : (
                        <svg className="flex-item svg-fill-circle margin-auto" width="17" height="5" viewBox="0 0 17 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="2.27778" cy="2.50054" r="1.77778" transform="rotate(-90 2.27778 2.50054)" fill="#9A9A9A"/>
                          <circle cx="8.50043" cy="2.50054" r="1.77778" transform="rotate(-90 8.50043 2.50054)" fill="#9A9A9A"/>
                          <circle cx="14.7231" cy="2.50054" r="1.77778" transform="rotate(-90 14.7231 2.50054)" fill="#9A9A9A"/>
                        </svg>
                      )
                    }

                    {
                      isGymActionDropdownOpenId == gym._id && (
                        <div className="table-action-menu scaleFromTopToBottom" style={getActionMenuStyle(dropdownPosition)}>
                          <div onClick={handleUpdateOpen(gym)} className="action-menu-item d-flex">
                            <div className="flex-item d-flex m-r-8" style={{width:"24px"}}>
                              <svg className='flex-item m-r-8' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.5828 1.41713C14.1024 0.936821 13.4508 0.666992 12.7715 0.666992C12.0921 0.666992 11.4406 0.936821 10.9602 1.41713L1.90097 10.4775C1.63678 10.7415 1.4545 11.0762 1.37606 11.4413L0.67774 14.6996C0.659324 14.7852 0.662646 14.874 0.687401 14.958C0.712157 15.0419 0.757556 15.1183 0.819453 15.1802C0.88135 15.2421 0.95777 15.2875 1.04173 15.3123C1.12569 15.337 1.21452 15.3403 1.3001 15.3219L4.55855 14.6237C4.92372 14.5452 5.25845 14.3629 5.52247 14.0988L14.5828 5.03896C15.0629 4.5586 15.3327 3.90722 15.3327 3.22804C15.3327 2.54886 15.0629 1.89749 14.5828 1.41713ZM11.7015 2.15784C11.9879 1.88696 12.3688 1.7385 12.763 1.74403C13.1572 1.74955 13.5337 1.90862 13.8124 2.18742C14.0912 2.46622 14.2502 2.84274 14.2556 3.23693C14.261 3.63112 14.1125 4.01188 13.8415 4.29825L13.37 4.7697L11.2295 2.62982L11.7015 2.15784ZM10.4882 3.37053L12.6287 5.51094L4.78225 13.3586C4.66083 13.4799 4.50692 13.5636 4.33905 13.5995L1.87111 14.1286L2.40022 11.6613C2.43615 11.4935 2.51983 11.3396 2.6412 11.2182L10.4882 3.37053Z" fill="var(--darkBlue)"/>
                              </svg>
                            </div>
                            <p className="flex-item">Edit</p>
                          </div>
                          <div onClick={handleStatusChangeAction} className="action-menu-item d-flex">
                            <div className="flex-item d-flex m-r-8" style={{width:"24px"}}>
                              <svg className='flex-item m-r-8' width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.196 4.76233C2.90164 5.86082 2.93963 7.02194 3.30516 8.09884C3.6707 9.17574 4.34737 10.1201 5.2496 10.8124C6.15183 11.5047 7.2391 11.914 8.37391 11.9883C9.50872 12.0627 10.6401 11.7989 11.625 11.2303M14.304 7.73833C14.5984 6.63984 14.5604 5.47873 14.1948 4.40183C13.8293 3.32492 13.1526 2.3806 12.2504 1.68827C11.3482 0.995947 10.2609 0.586711 9.1261 0.512318C7.99129 0.437925 6.8599 0.701717 5.875 1.27033" stroke="var(--darkBlue)" stroke-linecap="round"/>
                                <path d="M0.5 6.75034L3 4.25034L5.5 6.75034M12 5.75034L14.5 8.25034L17 5.75034" stroke="var(--darkBlue)" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                            <p className="flex-item">{(!gym.deletedAt || gym.deletedAt == null) ? `Mark Inactive` : `Mark Active`}</p>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    </div>,
      
    isAddGymModalOpen && <ManageGymForm isEdit={true} gym={{ ...selectedGym }} toggleAddGymModal={toggleAddGymModal.bind(this)} />,
    
    isStatusChangeModalOpen && <ManageConfirmationModal handleAction={handleAction} title={isBulkStatusChangeAction ? `${isAllGymChecked ? Gyms.length : selectedGymIds.length} gym(s) selected` : selectedGym.name} message="By performing this action all the user's under this gym will get effected" buttonText={`Mark ${isBulkStatusChangeAction ? (isGymActive ? "inactive" : "active") : (selectedGym.deletedAt == null ? "inactive" : "active")}`} handleClose={handleStatusChangeAction} />
  ]
}

export default CompaniesList;